import axiosInstance from "../utils/axios";

export async function getServices(id) {
  try {
    let response;
    if (id && id !== "all") {
      response = await axiosInstance.get(`get_category_services/${id}`);
    } else {
      response = await axiosInstance.get("get_Services");
    }
    const data = response.data.data;
    return data;
  } catch (err) {
    console.error("Error fetching services data:", err);
    return null;
  }
}

export async function getService(id) {
  try {
    const response = await axiosInstance.get(`service_details/${id}`);
    console.log("Service details response:", response.data);
    const data = response.data.data;
    return data;
  } catch (err) {
    console.error("Error fetching service details:", err?.response?.data || err);
    return null;
  }
}
